import React from "react";
import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";

// Pages
import Home from "./pages/Home";
import Traefaeldning from "./pages/Traefaeldning";
import Beskaering from "./pages/Beskaering";
import Raadgivning from "./pages/Raadgivning";
import Oprydning from "./pages/Oprydning";
import Redekasser from "./pages/Redekasser";
import Kontakt from "./pages/Kontakt";
import Privatlivspolitik from "./pages/Privatlivspolitik";
import NotFound from "./pages/NotFound";
import Forbidden from "./pages/Forbidden";

export default function App() {
  return (
    <HelmetProvider>
      <div className="flex flex-col min-h-screen bg-[#FBF9F5] text-[#15241C]">
        <ScrollToTop />
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/traefaeldning" element={<Traefaeldning />} />
            <Route path="/beskaering" element={<Beskaering />} />
            <Route path="/oprydning" element={<Oprydning />} />
            <Route path="/raadgivning" element={<Raadgivning />} />
            <Route path="/opsaetning-af-redekasser" element={<Redekasser />} />
            <Route path="/redekasser" element={<Redekasser />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/privatlivspolitik" element={<Privatlivspolitik />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}
